export const environment = {
    e2e: false,
    production: false,
    firebase: {
        apiKey: "AIzaSyAsRIN5QNCtNocxn5bBON_U4XV80EaZdSk",
        authDomain: "cwl-2047de3af612-qa.firebaseapp.com",
    },
    region: 'europe-west1',
    brain_base_url: 'https://blb.api-test.deloitte.camp',
    aoh_url: 'https://aoh-qa.blb.cwl.camp/',
    store_url: 'https://store-qa.blb.cwl.camp/',
    api_base_url: 'https://blb.api-test.deloitte.camp',
    authParams: ['oidc.blb', 'oidc.campfire'],
    signInType: 'signInWithPopup',
    hasEnterpriseAssetSearch: false,
    showBarrierQuestions: false,
    asset_redirect_uri: {},
    useBilling: false,
    upload: {
        allowUnclassifiedFilesUpload: true,
    },
    showInvitatio: false,
    hidePackagesAndPlans: true,
    business_hideServiceOfferings: true,
    business_hideIsIndustryAligned: true,
    business_hideIndustries: true,
    business_hideAlliances: true,
    business_hideRevenueForm: true,
    business_hideGeographyQuestion: true,
    business_hideBusinessLineAlignment: true,
    technical_hideContainerizedQuestion: true,
    technical_hideInformOnboardingTeamButton: true,
    hideBeforeYouStartPopup: true,
    business_hideOfficeAddress: true,
    entitlements: {
        aoh_hide_add_users_button: true,
        aoh_hide_deploy_button: true
    },
    hideBarrierSuccessPopup: true,
    postBarrierQuestionsRoute: ['technical', 'onboarding'],
    onboarding: {
        displayVideo: false,
        video_url: 'https://storage.googleapis.com/dcsp-catalog-assets-public/data/products/Deloitte%20AI%20Video/Deloitte%20AI%20-%20Asset%20Owner%20Hub.mp4',
        development: {
            frontend_url: 'https://storage.googleapis.com/dcsp-catalog-assets-public/data/products/Frontend_Development_Kit/Deloitte.AI%20Frontend%20Development%20Kit.pdf',
            backend_url: 'https://bitbucket.de.deloitte.com/projects/AI/repos/dcsp-python-framework/browse',
            business_support_email: 'mailto:campfire@deloitte.de?subject=Question%20regarding%20Deloitte%20AI%20Marketplace',
        },
    },
    barrierQuestionsAbort: {
        mailAddress: 'Support-bayernlb-AI@bayernlb.de',
    },
    support: {
        ccEmail: "Support-bayernlb-AI@bayernlb.de",
        contact: "mailto:campfire@deloitte.de?subject=Question%20regarding%20Deloitte%20AI%20Marketplace",
    },
    onboarding_options: {
        "gen_ai": {
            api_url: "https://blb-geniusai.connect-test.api.deloitte.ai",
            app_url: "https://geniusai-test.blb.cwl.camp/workflow-selector"
        }
    }
};
